import {AppConfig} from '@common/core/config/app-config';

export const COMMON_ADMIN_CONFIG: AppConfig = {
    admin: {
        tagTypes: [{name: 'custom'}],
        pages: [],
    }
};
